export default __webpack_public_path__ + "static/4-1958f9951d6401c88c0745afb2cb279f.jpeg";